
<template>
  <!--研报查看大图-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;overflow:hidden;" v-if="bigimgobj.show">
    <div class="index-flex-main">
      <div class="index-flex-box">
        <div class="login-close">
           <a class="delete-icon" href="javascript:;" @click="bigimgobj.show = false"></a>
        </div>


        <div class="intelligent-fsearch1">        
          <div class="fsearch-a">
            <!-- <div class="text-b">{{{bigimgobj.imghead}}}</div> -->
            <p class="text-b">{{{bigimgobj.imghead}}}</p>
            <p class="text-a"><img src="{{bigimgobj.imgurl}}"></p>
          </div>
          <p class="text-c">{{{bigimgobj.imgfoot}}}</p>       
        </div>

        <div class="text-right">
          <a class="btn-eit" href="javascript:;" @click="tpCollect(bigimgobj)">收藏</a>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-if="bigimgobj.show"></div>
  <!-- /研报查看大图 -->
</template>


<script>
import { apiUrl, alert } from '../helper'
import $ from 'jquery'
import userMix from '../common/userMix'

export default {
  props: ['bigimgobj'],
  mixins: [userMix],

  methods: {
    // 点击收藏图片按钮
    tpCollect: function (item) {
      console.log(item);
      let query = {};
      query.typ = 3;
      query.imgid = item.imgid;
      query.companycode = item.companycode;
      query.companyname = item.companyname;
      query.md5 = item.md5;
      query.publishdate = item.publishdate;
      // query.shortname = item.shortname;
      query.stype = item.stype;
      query.title = item.title;
      // query.source = item.source;


      $.ajax({
        url: apiUrl('/V1.0.0/user/collect'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          alert('收藏成功')
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
  }
}
</script>


/** WEBPACK FOOTER **
 ** BigImg.vue?4109213a
 **/